import type { StateCreator } from 'zustand';
import type { QueueItem } from '../types';
import { publishQueueApi } from '../services/publishQueueApi';

export interface PublishQueueSlice {
  queueItems: QueueItem[];
  queueLoading: boolean;
  fetchQueue: (params?: { manager_id?: number; status?: string }) => Promise<void>;
  updateQueueStatus: (id: number, status: string) => Promise<void>;
  assignContent: (id: number, managerId: number) => Promise<void>;
  addQueueItem: (data: Partial<QueueItem>) => Promise<number>;
  handleSSEUpdate: (data: { item_id: number; new_status: string }) => void;
}

export const createPublishQueueSlice: StateCreator<PublishQueueSlice> = (set, get) => ({
  queueItems: [],
  queueLoading: false,

  fetchQueue: async (params) => {
    set({ queueLoading: true });
    try {
      const items = await publishQueueApi.list(params);
      set({ queueItems: items, queueLoading: false });
    } catch {
      set({ queueLoading: false });
    }
  },

  updateQueueStatus: async (id, status) => {
    await publishQueueApi.updateStatus(id, status);
    set((s) => ({
      queueItems: s.queueItems.map((i) =>
        i.id === id ? { ...i, status: status as QueueItem['status'] } : i
      ),
    }));
  },

  assignContent: async (id, managerId) => {
    await publishQueueApi.assign(id, managerId);
    set((s) => ({
      queueItems: s.queueItems.map((i) =>
        i.id === id ? { ...i, status: 'sent', manager_id: managerId } : i
      ),
    }));
  },

  addQueueItem: async (data) => {
    const res = await publishQueueApi.create(data);
    get().fetchQueue();
    return res.id;
  },

  handleSSEUpdate: (data) => {
    set((s) => ({
      queueItems: s.queueItems.map((i) =>
        i.id === data.item_id
          ? { ...i, status: data.new_status as QueueItem['status'] }
          : i
      ),
    }));
  },
});
